// extracted by mini-css-extract-plugin
export default {"recos":"V4-z","productCardOverride":"W4-z","rowHasBadge":"X4-z"};